import { render, staticRenderFns } from "./orders-by-delivery-time-chart.vue?vue&type=template&id=24000684&scoped=true&"
import script from "./orders-by-delivery-time-chart.vue?vue&type=script&lang=js&"
export * from "./orders-by-delivery-time-chart.vue?vue&type=script&lang=js&"
import style0 from "./orders-by-delivery-time-chart.vue?vue&type=style&index=0&id=24000684&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24000684",
  null
  
)

export default component.exports